import React from "react";
import { Link, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();
  const pathname = location.pathname || "";

  // Decide logo behavior based on current route
  const isOnboarding = pathname.startsWith("/onboarding");
  const isAuth = pathname.startsWith("/auth");
  const isQuestionnaire = pathname.startsWith("/PicklQuestionnaire") || pathname.startsWith("/full-questionnaire");

  let logoContent;
  if (isOnboarding) {
    // Stay on the same page: render plain image with no link
    logoContent = (
      <img
        src={require('../../images/pickl_logo_white.png')}
        alt="Pickl"
        className="header-logo"
      />
    );
  } else {
    // Auth → go to landing; Questionnaire (and default) → go to home
    const destination = isAuth ? "/landing" : "/home";
    logoContent = (
      <Link to={destination}>
        <img
          src={require('../../images/pickl_logo_white.png')}
          alt="Pickl"
          className="header-logo"
        />
      </Link>
    );
  }

  return (
    <header className="header">
      <div className="header-content">
        {logoContent}
      </div>
    </header>
  );
}

export default Header;
